import React from 'react';
import { SettingsRow, SettingsSection } from '../configuracoes/estabelecimento/Form/SettingsGroup';
import './Clientes.css';

export type SelfSchedulingBlockMode = 'ALL' | 'WEEK_DAYS';

export interface SelfSchedulingRestrictionValue {
  blocked: boolean;
  mode: SelfSchedulingBlockMode;
  weekDays: number[];
}

const WEEK_DAYS = [
  { value: 0, label: 'Dom', name: 'Domingo' },
  { value: 1, label: 'Seg', name: 'Segunda-feira' },
  { value: 2, label: 'Ter', name: 'Terça-feira' },
  { value: 3, label: 'Qua', name: 'Quarta-feira' },
  { value: 4, label: 'Qui', name: 'Quinta-feira' },
  { value: 5, label: 'Sex', name: 'Sexta-feira' },
  { value: 6, label: 'Sáb', name: 'Sábado' },
];

export function SelfSchedulingRestrictionFields({
  value,
  onChange,
  disabled,
}: {
  value: SelfSchedulingRestrictionValue;
  onChange: (next: SelfSchedulingRestrictionValue) => void;
  disabled?: boolean;
}) {
  const setBlocked = (blocked: boolean) => {
    onChange({
      ...value,
      blocked,
      mode: blocked ? value.mode : 'ALL',
      weekDays: blocked ? value.weekDays : [],
    });
  };

  const setMode = (mode: SelfSchedulingBlockMode) => {
    onChange({
      ...value,
      mode,
      weekDays: mode === 'WEEK_DAYS' ? value.weekDays : [],
    });
  };

  const toggleDay = (day: number) => {
    const exists = value.weekDays.includes(day);
    const nextWeekDays = exists
      ? value.weekDays.filter((current) => current !== day)
      : [...value.weekDays, day].sort((a, b) => a - b);

    onChange({
      ...value,
      weekDays: nextWeekDays,
    });
  };

  return (
    <SettingsSection
      title="Autoagendamento"
      footer="Bloqueia apenas novos agendamentos iniciados pelo cliente. A equipe continua podendo agendar."
    >
      <SettingsRow label="Bloquear autoagendamento" htmlFor="selfSchedulingBlocked" inline>
        <input
          id="selfSchedulingBlocked"
          type="checkbox"
          className="toggle toggle-success"
          checked={value.blocked}
          onChange={(e) => setBlocked(e.target.checked)}
          disabled={disabled}
        />
      </SettingsRow>

      {value.blocked && (
        <SettingsRow stacked>
          <div className="sf-segmented" role="group" aria-label="Período do bloqueio">
            <button
              type="button"
              aria-pressed={value.mode === 'ALL'}
              onClick={() => setMode('ALL')}
              disabled={disabled}
            >
              Todos os dias
            </button>
            <button
              type="button"
              aria-pressed={value.mode === 'WEEK_DAYS'}
              onClick={() => setMode('WEEK_DAYS')}
              disabled={disabled}
            >
              Dias específicos
            </button>
          </div>
        </SettingsRow>
      )}

      {value.blocked && value.mode === 'WEEK_DAYS' && (
        <SettingsRow stacked>
          <div className="cli-days" role="group" aria-label="Dias bloqueados">
            {WEEK_DAYS.map((day) => (
              <button
                key={day.value}
                type="button"
                className="cli-day"
                aria-pressed={value.weekDays.includes(day.value)}
                aria-label={day.name}
                onClick={() => toggleDay(day.value)}
                disabled={disabled}
              >
                {day.label}
              </button>
            ))}
          </div>
          {value.weekDays.length === 0 && (
            <div className="estab-row-description">Selecione ao menos um dia para bloquear.</div>
          )}
        </SettingsRow>
      )}
    </SettingsSection>
  );
}
